import { DataProvider } from 'react-admin';
import {
    DeleteBranchParams,
    DeleteBranchResult,
    TreeDataProvider,
    TreeRecord,
} from '../../types';

/**
 * If the API handles children of a node when it is deleted, this function
 * augments the existing dataProvider with a deleteBranch implementation which will
 * just use the default delete method of the dataProvider.
 *
 * @warning Do not use in production.
 *
 * The added Tree methods call the API way too much, sometimes asking for the
 * entire tree. In practice, you should implement an optimized API route for
 * each of the Tree methods.
 *
 * @param dataProvider The dataProvider with tree support
 */
export const deleteBranchByDeletingNode = async <
    ResourceType extends string = string,
    RecordType extends TreeRecord = TreeRecord
>(
    dataProvider: DataProvider<ResourceType> & TreeDataProvider<ResourceType>,
    resource: ResourceType,
    params: DeleteBranchParams<RecordType>
): Promise<DeleteBranchResult<RecordType>> => {
    await dataProvider.delete(resource, params);

    return { data: params.previousData };
};
